import { cn } from "@/lib/utils";
import { LoaderIcon } from "lucide-react";

interface Props {
  isLoading: boolean;
  children: React.ReactNode;
}

export const LoadingOverlay: React.FC<Props> = ({ isLoading, children }) => {
  return (
    <div className={cn(isLoading && "relative flex items-center justify-center pointer-events-none")}>
      <div className="w-full">{children}</div>
      {isLoading && <LoaderIcon className="animate-spin w-8 h-8 absolute" />}
    </div>
  );
};
